import React from 'react'
import BackgroundYoutube from '../BackgroundVideo/BackgroundYoutube'
import hasBackgroundTrailer from '../hoc/hasBackgroundTrailer'
import widthMaybeTrailer from '../hooks/widthMaybeTrailer'
import ItemPoster from './ItemPoster'


const ItemSwitch = ({title, poster, translation, isMobile, shouldPlayTrailer, maybeVideo, hasYoutubeCookieConfirmation, isReady, videoLoaded, youtubeId, trailerTime, onPlayerReady, onPlayerStateChange, onPlayerEnd, onPlayerUmount}) => {
    const trailerDisplayStyles = {
        display: videoLoaded ? 'block' : 'none'
    }

    return (
        <>
            <ItemPoster
                title={title} 
                poster={poster} 
                isMobile={isMobile}
                translation={translation} 
                onClick={() => {}} 
            />

            {(shouldPlayTrailer && true === maybeVideo && true === hasYoutubeCookieConfirmation && isReady) &&         
                <div className="grid-trailer" style={trailerDisplayStyles}>
                    <BackgroundYoutube
                        width="747"
                        height="420"
                        iframeClass="grid-trailer-iframes"
                        youtubeId={youtubeId}
                        trailerTime={trailerTime}
                        onPlayerReady={onPlayerReady}
                        onPlayerStateChange={onPlayerStateChange}
                        onPlayerEnd={onPlayerEnd}
                        onPlayerUmount={onPlayerUmount}
                    />
                </div>
            }
        </>
    )
}



export default widthMaybeTrailer(hasBackgroundTrailer(ItemSwitch))